module.exports = __webpack_public_path__ + "img/driver.b2479cbf.png";